import { useQuery } from '@tanstack/react-query';
import { useAuth } from './use-auth';
import { getDailyBriefing } from '../services/health-intelligence-service';
import type { DailyHealthBriefing } from '../types/health-intelligence-types';

export const briefingKeys = {
  all: ['dailyBriefing'] as const,
  current: (userId: string | undefined, firstName: string | undefined) =>
    [...briefingKeys.all, userId, firstName] as const,
};

/**
 * Hook to fetch the daily health briefing for the current user
 *
 * @returns Query result with briefing data
 */
export const useDailyBriefing = () => {
  const { user } = useAuth();
  const userId = user?.id;
  const firstName = user?.firstName || undefined;

  const queryResult = useQuery<DailyHealthBriefing | null>({
    queryKey: briefingKeys.current(userId, firstName),
    queryFn: () => getDailyBriefing(userId!, firstName),
    enabled: !!userId,
    staleTime: 60 * 60 * 1000, // 1 hour - briefing doesn't change often
  });

  return {
    ...queryResult,
    briefing: queryResult.data ?? null,
  };
};
